import React from 'react';
import moment from 'moment';
import NoData from 'components/_common/NoData';
import PageUtil from 'utils/Page.util';

/**
 * AS캘린더 뷰 컴포넌트
 * - 왼쪽: 출장일자 미정 목록
 * - 오른쪽: 월별 캘린더
 */
function AsCalendarV(props) {
    const { params, onChangeMonth, onSelectDate, onDropToCalendar, onOpenCreate, onOpenEdit } = props;

    // 캘린더 렌더링을 위한 날짜 계산
    const generateCalendarDays = () => {
        const year = params.currentYear;
        const month = params.currentMonth;

        const firstDay = moment(`${year}-${String(month).padStart(2, '0')}-01`);
        const lastDay = firstDay.clone().endOf('month');

        const startDate = firstDay.clone().startOf('week'); // 주의 시작 (일요일)
        const endDate = lastDay.clone().endOf('week'); // 주의 끝 (토요일)

        const days = [];
        let current = startDate.clone();

        while (current.isSameOrBefore(endDate)) {
            days.push({
                date: current.format('YYYY-MM-DD'),
                day: current.date(),
                isCurrentMonth: current.month() + 1 === month,
                isToday: current.isSame(moment(), 'day'),
            });
            current.add(1, 'day');
        }

        return days;
    };

    const calendarDays = generateCalendarDays();

    // 특정 날짜의 출장 목록 가져오기
    const getTripsByDate = (date) => {
        return params.calendarList.filter(item =>
            item.tripCard?.tripDate === date
        );
    };

    // 드래그 시작
    const handleDragStart = (e, reception) => {
        e.dataTransfer.setData('reception', JSON.stringify(reception));
        e.dataTransfer.effectAllowed = 'move';
    };

    // 드래그 오버
    const handleDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    };

    // 드롭
    const handleDrop = (e, targetDate) => {
        e.preventDefault();
        const receptionData = e.dataTransfer.getData('reception');
        if (receptionData) {
            const reception = JSON.parse(receptionData);
            onDropToCalendar(reception, targetDate);
        }
    };

    return (
        <div className="container-fluid">
            <div className="row">
                {/* 우측: 캘린더 */}
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="d-flex justify-content-between align-items-center">
                                <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() => onChangeMonth('prev')}
                                >
                                    ◀ 이전
                                </button>

                                <h3 className="card-title mb-0">
                                    {params.currentYear}년 {params.currentMonth}월
                                </h3>

                                <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() => onChangeMonth('next')}
                                >
                                    다음 ▶
                                </button>
                            </div>
                        </div>
                        <div className="card-body p-2">
                            <table className="table table-bordered" style={{ tableLayout: 'fixed' }}>
                                <thead>
                                    <tr>
                                        <th className="text-center bg-light" style={{ width: '14.28%' }}>일</th>
                                        <th className="text-center bg-light" style={{ width: '14.28%' }}>월</th>
                                        <th className="text-center bg-light" style={{ width: '14.28%' }}>화</th>
                                        <th className="text-center bg-light" style={{ width: '14.28%' }}>수</th>
                                        <th className="text-center bg-light" style={{ width: '14.28%' }}>목</th>
                                        <th className="text-center bg-light" style={{ width: '14.28%' }}>금</th>
                                        <th className="text-center bg-light" style={{ width: '14.28%' }}>토</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.from({ length: Math.ceil(calendarDays.length / 7) }).map((_, weekIdx) => (
                                        <tr key={weekIdx}>
                                            {calendarDays.slice(weekIdx * 7, weekIdx * 7 + 7).map((dayInfo, dayIdx) => {
                                                const tripsOnThisDay = getTripsByDate(dayInfo.date);

                                                return (
                                                    <td
                                                        key={dayIdx}
                                                        className={`
                                                            ${!dayInfo.isCurrentMonth ? 'bg-light text-muted' : ''}
                                                            ${dayInfo.isToday ? 'bg-warning' : ''}
                                                        `}
                                                        style={{
                                                            height: '100px',
                                                            verticalAlign: 'top',
                                                            position: 'relative',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={() => onSelectDate(dayInfo.date)}
                                                        onDragOver={handleDragOver}
                                                        onDrop={(e) => handleDrop(e, dayInfo.date)}
                                                        onDoubleClick={(e) => onOpenCreate(e, dayInfo.date)}
                                                    >
                                                        <div className="d-flex justify-content-between">
                                                            <strong>{dayInfo.day}</strong>
                                                            {tripsOnThisDay.length > 0 && (
                                                                <span className="badge badge-primary badge-sm">
                                                                    {tripsOnThisDay.length}
                                                                </span>
                                                            )}
                                                        </div>

                                                        <div className="mt-1" style={{ fontSize: '0.75rem' }}>
                                                            {tripsOnThisDay.map((trip, idx) => (
                                                                <div
                                                                    key={idx}
                                                                    // className="mb-1 p-1 bg-info text-white rounded"
                                                                    className={`
                                                                        mb-1 p-1 text-white rounded  ${["노승균", "유동수", "신용선", "강성인", "정찬권"].find(p => p == trip?.tripCard?.agent) ? "bg-info" : "bg-success"}
                                                                    `}
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        onOpenEdit(trip);
                                                                    }}
                                                                    draggable
                                                                    onDragStart={(e) => handleDragStart(e, trip)}
                                                                >
                                                                    <div style={{ fontSize: '0.7rem' }}>
                                                                        {/* {trip?.tripCard?.address || (trip?.province + "" + trip?.city) || '지역 미상'} */}
                                                                        {(trip?.province && trip?.city) ? (trip?.province + " " + trip?.city) : trip?.tripCard?.address || '지역 미상'}
                                                                        {' ' + trip?.customerName ? trip?.customerName : ""}
                                                                    </div>
                                                                    <div style={{ fontSize: '0.7rem' }}>
                                                                        {trip.tripCard?.agent || '출장자 미정'}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                {/* 출장일자미정 목록 */}
                <div className="col-md-12">
                    <div className="card card-outline card-dark">
                        <div className="card-header">
                            <div className="card-title">출장일자미정</div>
                            <div className="card-tools">
                                <span className="badge bg-secondary">
                                    {PageUtil.formatToKRW(params?.undecidedList?.length)} 건
                                </span>
                            </div>
                        </div>
                        <div className="card-body table-responsive p-0">
                            {params?.undecidedList?.length === 0 ? (
                                <NoData />
                            ) : (
                                <div className="row">
                                    {/* 좌측 테이블 */}
                                    <div className="col-md-6">
                                        <table className="table text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>연락처</th>
                                                    <th>고객명</th>
                                                    <th>도</th>
                                                    <th>지역</th>
                                                    <th>출장자</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {params?.undecidedList?.slice(0, Math.ceil(params?.undecidedList?.length / 2)).map((row) => (
                                                    <tr className='hover-light' key={row.id} style={row.blacklist ? { backgroundColor: '#ffe6e6', cursor: 'pointer' } : { cursor: 'pointer' }} onClick={() => onOpenEdit(row)}>
                                                        <td>
                                                            {row.phone1 || ''}
                                                        </td>
                                                        <td>
                                                            <strong>{row.customerName || ''}</strong>
                                                        </td>
                                                        <td>
                                                            {row.province || ''}
                                                        </td>
                                                        <td>
                                                            {row.city || ''}
                                                        </td>
                                                        <td>
                                                            {row.tripCard?.agent || ''}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* 우측 테이블 */}
                                    <div className="col-md-6">
                                        <table className="table text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th>연락처</th>
                                                    <th>고객명</th>
                                                    <th>도</th>
                                                    <th>지역</th>
                                                    <th>출장자</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {params?.undecidedList?.slice(Math.ceil(params?.undecidedList?.length / 2)).map((row) => (
                                                    <tr className='hover-light' key={row.id} style={row.blacklist ? { backgroundColor: '#ffe6e6', cursor: 'pointer' } : { cursor: 'pointer' }} onClick={() => onOpenEdit(row)}>
                                                        <td>
                                                            {row.phone1 || ''}
                                                        </td>
                                                        <td>
                                                            <strong>{row.customerName || ''}</strong>
                                                        </td>
                                                        <td>
                                                            {row.province || ''}
                                                        </td>
                                                        <td>
                                                            {row.city || ''}
                                                        </td>
                                                        <td>
                                                            {row.tripCard?.agent || ''}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AsCalendarV;